import { usePageTitle } from "~/hooks/usePageTitle";

import styles from "./BaseReportsPage.module.scss";

const BaseReportsPage = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  usePageTitle(title);

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{title}</h1>
      {children}
    </div>
  );
};

export default BaseReportsPage;
